// extracted by mini-css-extract-plugin
export default {"tabla":"Categorias_tabla__BTMBI","rows":"Categorias_rows__rVAlj","rows_head":"Categorias_rows_head__hnexz","col_edit":"Categorias_col_edit__5Wbxi","add":"Categorias_add__IeNK7"};